export var AccountType;
(function (AccountType) {
    AccountType["Eoa"] = "eoa";
    AccountType["Sca"] = "sca";
})(AccountType || (AccountType = {}));
export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["Cancelled"] = "cancelled";
    ActivityStatus["Failed"] = "failed";
    ActivityStatus["NotFound"] = "not_found";
    ActivityStatus["Pending"] = "pending";
    ActivityStatus["Successful"] = "successful";
    ActivityStatus["WaitingGasAbstraction"] = "waiting_gas_abstraction";
    ActivityStatus["WaitingPrecondition"] = "waiting_precondition";
    ActivityStatus["WaitingTimeout"] = "waiting_timeout";
    ActivityStatus["WaitingTokenApprovalTransactions"] = "waiting_token_approval_transactions";
})(ActivityStatus || (ActivityStatus = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["Bridge"] = "bridge";
    ActivityType["Correction"] = "correction";
    ActivityType["Deposit"] = "deposit";
    ActivityType["FunctionCall"] = "function_call";
    ActivityType["Funding"] = "funding";
    ActivityType["Margin"] = "margin";
    ActivityType["PerpClose"] = "perp_close";
    ActivityType["PerpOpen"] = "perp_open";
    ActivityType["PerpReduce"] = "perp_reduce";
    ActivityType["PredictionBuy"] = "prediction_buy";
    ActivityType["PredictionResolution"] = "prediction_resolution";
    ActivityType["PredictionSell"] = "prediction_sell";
    ActivityType["Rebalance"] = "rebalance";
    ActivityType["Receive"] = "receive";
    ActivityType["Send"] = "send";
    ActivityType["Swap"] = "swap";
    ActivityType["SwapLeg"] = "swap_leg";
    ActivityType["TypedDataSignature"] = "typed_data_signature";
    ActivityType["Withdrawal"] = "withdrawal";
})(ActivityType || (ActivityType = {}));
export var AlertTargetType;
(function (AlertTargetType) {
    AlertTargetType["Account"] = "account";
    AlertTargetType["Instrument"] = "instrument";
    AlertTargetType["PredictionMarket"] = "prediction_market";
    AlertTargetType["Trader"] = "trader";
})(AlertTargetType || (AlertTargetType = {}));
export var AlertType;
(function (AlertType) {
    AlertType["BalanceChange"] = "balance_change";
    AlertType["FollowedTrade"] = "followed_trade";
    AlertType["FundingRate"] = "funding_rate";
    AlertType["LargeTransfer"] = "large_transfer";
    AlertType["LiquidationCascade"] = "liquidation_cascade";
    AlertType["LiquidityChange"] = "liquidity_change";
    AlertType["MarketResolution"] = "market_resolution";
    AlertType["OutcomeResolved"] = "outcome_resolved";
    AlertType["PriceAbove"] = "price_above";
    AlertType["PriceBelow"] = "price_below";
    AlertType["PriceChangePct"] = "price_change_pct";
    AlertType["PriceMove"] = "price_move";
    AlertType["TradeExecuted"] = "trade_executed";
    AlertType["VolumeSpike"] = "volume_spike";
})(AlertType || (AlertType = {}));
export var AuthType;
(function (AuthType) {
    AuthType["Email"] = "email";
    AuthType["Phone"] = "phone";
    AuthType["Wallet"] = "wallet";
})(AuthType || (AuthType = {}));
export var BalanceImpact;
(function (BalanceImpact) {
    BalanceImpact["Negative"] = "negative";
    BalanceImpact["Positive"] = "positive";
})(BalanceImpact || (BalanceImpact = {}));
export var Category;
(function (Category) {
    Category["Approve"] = "approve";
    Category["Bridge"] = "bridge";
    Category["Correction"] = "correction";
    Category["Deposit"] = "deposit";
    Category["FunctionCall"] = "function_call";
    Category["Funding"] = "funding";
    Category["Margin"] = "margin";
    Category["PerpClose"] = "perp_close";
    Category["PerpOpen"] = "perp_open";
    Category["PerpReduce"] = "perp_reduce";
    Category["PredictionBuy"] = "prediction_buy";
    Category["PredictionResolution"] = "prediction_resolution";
    Category["PredictionSell"] = "prediction_sell";
    Category["Rebalance"] = "rebalance";
    Category["Receive"] = "receive";
    Category["Send"] = "send";
    Category["Swap"] = "swap";
    Category["SwapLeg"] = "swap_leg";
    Category["TypedDataSignature"] = "typed_data_signature";
    Category["Withdrawal"] = "withdrawal";
})(Category || (Category = {}));
export var ChartTimeframe;
(function (ChartTimeframe) {
    ChartTimeframe["All"] = "all";
    ChartTimeframe["FiveMinutes"] = "five_minutes";
    ChartTimeframe["FourHours"] = "four_hours";
    ChartTimeframe["OneDay"] = "one_day";
    ChartTimeframe["OneHour"] = "one_hour";
    ChartTimeframe["OneMonth"] = "one_month";
    ChartTimeframe["OneYear"] = "one_year";
    ChartTimeframe["SevenDays"] = "seven_days";
    ChartTimeframe["SixMonths"] = "six_months";
})(ChartTimeframe || (ChartTimeframe = {}));
/**
 * Sort order for closed positions returned by
 * getPositions(input: { status: closed, sortBy: ... }). Open positions use
 * the per-rail sub-type resolvers on PortfolioPositions and ignore sortBy.
 */
export var ClosedPositionSort;
(function (ClosedPositionSort) {
    ClosedPositionSort["ClosedAtDesc"] = "closed_at_desc";
    ClosedPositionSort["CostBasisDesc"] = "cost_basis_desc";
    ClosedPositionSort["RealizedPnlAsc"] = "realized_pnl_asc";
    ClosedPositionSort["RealizedPnlDesc"] = "realized_pnl_desc";
})(ClosedPositionSort || (ClosedPositionSort = {}));
export var CustomErrorCode;
(function (CustomErrorCode) {
    CustomErrorCode["InsufficientFunds"] = "insufficient_funds";
    CustomErrorCode["NoRouteFound"] = "no_route_found";
    CustomErrorCode["TokensNotFromSameChain"] = "tokens_not_from_same_chain";
})(CustomErrorCode || (CustomErrorCode = {}));
export var DataInjectionRuleType;
(function (DataInjectionRuleType) {
    DataInjectionRuleType["Automatic"] = "automatic";
    DataInjectionRuleType["Manual"] = "manual";
    DataInjectionRuleType["Undefined"] = "undefined";
})(DataInjectionRuleType || (DataInjectionRuleType = {}));
export var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["Android"] = "android";
    DevicePlatform["Ios"] = "ios";
    DevicePlatform["Web"] = "web";
})(DevicePlatform || (DevicePlatform = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["Android"] = "android";
    DeviceType["Ios"] = "ios";
    DeviceType["Macos"] = "macos";
    DeviceType["Web"] = "web";
    DeviceType["Windows"] = "windows";
})(DeviceType || (DeviceType = {}));
export var FeeCollectionTarget;
(function (FeeCollectionTarget) {
    FeeCollectionTarget["AllTransactions"] = "all_transactions";
    FeeCollectionTarget["BridgingTransactions"] = "bridging_transactions";
    FeeCollectionTarget["GasTransactions"] = "gas_transactions";
    FeeCollectionTarget["None"] = "none";
})(FeeCollectionTarget || (FeeCollectionTarget = {}));
export var FeeCollectionUnit;
(function (FeeCollectionUnit) {
    FeeCollectionUnit["Fixed"] = "fixed";
    FeeCollectionUnit["Percentage"] = "percentage";
    FeeCollectionUnit["PercentageWithCap"] = "percentage_with_cap";
})(FeeCollectionUnit || (FeeCollectionUnit = {}));
export var FilterGroupLayout;
(function (FilterGroupLayout) {
    FilterGroupLayout["EightColumnList"] = "eight_column_list";
    FilterGroupLayout["FiveColumnList"] = "five_column_list";
    FilterGroupLayout["FourColumnList"] = "four_column_list";
    FilterGroupLayout["NineColumnList"] = "nine_column_list";
    FilterGroupLayout["OneColumnList"] = "one_column_list";
    FilterGroupLayout["SevenColumnList"] = "seven_column_list";
    FilterGroupLayout["SixColumnList"] = "six_column_list";
    FilterGroupLayout["TenColumnList"] = "ten_column_list";
    FilterGroupLayout["ThreeColumnList"] = "three_column_list";
    FilterGroupLayout["TwoColumnList"] = "two_column_list";
})(FilterGroupLayout || (FilterGroupLayout = {}));
export var FormFieldAction;
(function (FormFieldAction) {
    FormFieldAction["OpenBankSelector"] = "open_bank_selector";
    FormFieldAction["OpenChainSelector"] = "open_chain_selector";
    FormFieldAction["OpenCountrySelector"] = "open_country_selector";
    FormFieldAction["OpenCurrencySelector"] = "open_currency_selector";
    FormFieldAction["OpenRecipientSelector"] = "open_recipient_selector";
    FormFieldAction["OpenTokenSelector"] = "open_token_selector";
})(FormFieldAction || (FormFieldAction = {}));
export var FormFieldType;
(function (FormFieldType) {
    FormFieldType["AccountNumber"] = "account_number";
    FormFieldType["Checkbox"] = "checkbox";
    FormFieldType["Date"] = "date";
    FormFieldType["Email"] = "email";
    FormFieldType["Iban"] = "iban";
    FormFieldType["Number"] = "number";
    FormFieldType["Phone"] = "phone";
    FormFieldType["RoutingNumber"] = "routing_number";
    FormFieldType["Select"] = "select";
    FormFieldType["SortCode"] = "sort_code";
    FormFieldType["SwiftCode"] = "swift_code";
    FormFieldType["Text"] = "text";
})(FormFieldType || (FormFieldType = {}));
export var FormFieldValidationType;
(function (FormFieldValidationType) {
    FormFieldValidationType["IbanFormat"] = "iban_format";
    FormFieldValidationType["MaxLength"] = "max_length";
    FormFieldValidationType["MaxValue"] = "max_value";
    FormFieldValidationType["MinLength"] = "min_length";
    FormFieldValidationType["MinValue"] = "min_value";
    FormFieldValidationType["Regex"] = "regex";
    FormFieldValidationType["Required"] = "required";
    FormFieldValidationType["SwiftFormat"] = "swift_format";
})(FormFieldValidationType || (FormFieldValidationType = {}));
export var InstrumentType;
(function (InstrumentType) {
    InstrumentType["FungibleToken"] = "fungible_token";
    InstrumentType["NonFungibleToken"] = "non_fungible_token";
    InstrumentType["PerpetualContract"] = "perpetual_contract";
    InstrumentType["PredictionMarket"] = "prediction_market";
    InstrumentType["SemiFungibleToken"] = "semi_fungible_token";
})(InstrumentType || (InstrumentType = {}));
export var LeverageType;
(function (LeverageType) {
    LeverageType["Cross"] = "cross";
    LeverageType["Isolated"] = "isolated";
})(LeverageType || (LeverageType = {}));
export var LibraryName;
(function (LibraryName) {
    LibraryName["Rukh"] = "rukh";
    LibraryName["Thunderbird"] = "thunderbird";
})(LibraryName || (LibraryName = {}));
export var MarketType;
(function (MarketType) {
    MarketType["Perps"] = "perps";
    MarketType["PredictionMarket"] = "prediction_market";
    MarketType["Spot"] = "spot";
})(MarketType || (MarketType = {}));
export var OAuthPermissionLevel;
(function (OAuthPermissionLevel) {
    OAuthPermissionLevel["Read"] = "read";
    OAuthPermissionLevel["ReadAndWrite"] = "read_and_write";
    OAuthPermissionLevel["Write"] = "write";
})(OAuthPermissionLevel || (OAuthPermissionLevel = {}));
export var OperationDataFormat;
(function (OperationDataFormat) {
    OperationDataFormat["Transaction"] = "transaction";
    OperationDataFormat["TypedData"] = "typed_data";
})(OperationDataFormat || (OperationDataFormat = {}));
export var OperationStatusType;
(function (OperationStatusType) {
    OperationStatusType["Cancelled"] = "cancelled";
    OperationStatusType["Failed"] = "failed";
    OperationStatusType["NotFound"] = "not_found";
    OperationStatusType["Pending"] = "pending";
    OperationStatusType["Successful"] = "successful";
    OperationStatusType["WaitingGasAbstraction"] = "waiting_gas_abstraction";
    OperationStatusType["WaitingPrecondition"] = "waiting_precondition";
    OperationStatusType["WaitingTimeout"] = "waiting_timeout";
    OperationStatusType["WaitingTokenApprovalTransactions"] = "waiting_token_approval_transactions";
})(OperationStatusType || (OperationStatusType = {}));
export var OperationType;
(function (OperationType) {
    OperationType["ApproveErc20Token"] = "approve_erc20_token";
    OperationType["CancelOperation"] = "cancel_operation";
    OperationType["CancelTransaction"] = "cancel_transaction";
    OperationType["FinalTransaction"] = "final_transaction";
    OperationType["GasAbstraction"] = "gas_abstraction";
    OperationType["NativeTokenTransfer"] = "native_token_transfer";
    OperationType["SubmitIntent"] = "submit_intent";
})(OperationType || (OperationType = {}));
export var Order;
(function (Order) {
    Order["Newest"] = "newest";
    Order["Oldest"] = "oldest";
})(Order || (Order = {}));
export var OrderSide;
(function (OrderSide) {
    OrderSide["Buy"] = "buy";
    OrderSide["Sell"] = "sell";
})(OrderSide || (OrderSide = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Filled"] = "filled";
    OrderStatus["Open"] = "open";
    OrderStatus["PartiallyFilled"] = "partially_filled";
    OrderStatus["Rejected"] = "rejected";
})(OrderStatus || (OrderStatus = {}));
export var OrderType;
(function (OrderType) {
    OrderType["Fok"] = "fok";
    OrderType["Ioc"] = "ioc";
    OrderType["Limit"] = "limit";
    OrderType["Market"] = "market";
    OrderType["PostOnly"] = "post_only";
    OrderType["Twap"] = "twap";
})(OrderType || (OrderType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["ApplePay"] = "apple_pay";
    PaymentMethod["BankTransferAfrica"] = "bank_transfer_africa";
    PaymentMethod["Card"] = "card";
    PaymentMethod["CashPickup"] = "cash_pickup";
    PaymentMethod["GooglePay"] = "google_pay";
    PaymentMethod["Interac"] = "interac";
    PaymentMethod["MobileMoney"] = "mobile_money";
    PaymentMethod["OnchainTransfer"] = "onchain_transfer";
    PaymentMethod["Pix"] = "pix";
    PaymentMethod["Sepa"] = "sepa";
    PaymentMethod["SepaInstant"] = "sepa_instant";
    PaymentMethod["Spei"] = "spei";
    PaymentMethod["Swift"] = "swift";
    PaymentMethod["UkFasterPayments"] = "uk_faster_payments";
    PaymentMethod["UsAch"] = "us_ach";
    PaymentMethod["UsWire"] = "us_wire";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Deposit"] = "deposit";
    PaymentType["Receive"] = "receive";
    PaymentType["Send"] = "send";
    PaymentType["Spend"] = "spend";
    PaymentType["Withdraw"] = "withdraw";
})(PaymentType || (PaymentType = {}));
export var PerformanceGroupBy;
(function (PerformanceGroupBy) {
    PerformanceGroupBy["Category"] = "category";
    PerformanceGroupBy["Market"] = "market";
})(PerformanceGroupBy || (PerformanceGroupBy = {}));
/**
 * How a perp fill changed the trader's position — derived from the fill
 * size/side against the position before it.
 */
export var PerpPositionAction;
(function (PerpPositionAction) {
    PerpPositionAction["Close"] = "close";
    PerpPositionAction["Flip"] = "flip";
    PerpPositionAction["Increase"] = "increase";
    PerpPositionAction["Open"] = "open";
    PerpPositionAction["Reduce"] = "reduce";
})(PerpPositionAction || (PerpPositionAction = {}));
export var PerpsVenue;
(function (PerpsVenue) {
    PerpsVenue["Hyperliquid"] = "hyperliquid";
})(PerpsVenue || (PerpsVenue = {}));
export var Platform;
(function (Platform) {
    Platform["Arbitrum"] = "arbitrum";
    Platform["ArbitrumGoerli"] = "arbitrum_goerli";
    Platform["ArbitrumSepolia"] = "arbitrum_sepolia";
    Platform["Avalanche"] = "avalanche";
    Platform["Base"] = "base";
    Platform["BaseSepolia"] = "base_sepolia";
    Platform["Binance"] = "binance";
    Platform["BinanceTestnet"] = "binance_testnet";
    Platform["Ethereum"] = "ethereum";
    Platform["EthereumGoerli"] = "ethereum_goerli";
    Platform["EthereumHolesky"] = "ethereum_holesky";
    Platform["EthereumSepolia"] = "ethereum_sepolia";
    Platform["Evmos"] = "evmos";
    Platform["LocalChain_0"] = "local_chain_0";
    Platform["LocalChain_1"] = "local_chain_1";
    Platform["Mantle"] = "mantle";
    Platform["MantleSepolia"] = "mantle_sepolia";
    Platform["Moonbeam"] = "moonbeam";
    Platform["MoonbeamAlpha"] = "moonbeam_alpha";
    Platform["OpbnbTestnet"] = "opbnb_testnet";
    Platform["Optimism"] = "optimism";
    Platform["OptimismGoerli"] = "optimism_goerli";
    Platform["OptimismSepolia"] = "optimism_sepolia";
    Platform["Polygon"] = "polygon";
    Platform["PolygonAmoy"] = "polygon_amoy";
    Platform["Solana"] = "solana";
    Platform["Sonic"] = "sonic";
    Platform["SonicBlaze"] = "sonic_blaze";
})(Platform || (Platform = {}));
export var PlatformEnvironment;
(function (PlatformEnvironment) {
    PlatformEnvironment["Mainnet"] = "mainnet";
    PlatformEnvironment["Testnet"] = "testnet";
})(PlatformEnvironment || (PlatformEnvironment = {}));
export var PlatformSupportStatus;
(function (PlatformSupportStatus) {
    PlatformSupportStatus["AccountUnavailable"] = "account_unavailable";
    PlatformSupportStatus["PlatformSupported"] = "platform_supported";
    PlatformSupportStatus["PlatformUnavailable"] = "platform_unavailable";
})(PlatformSupportStatus || (PlatformSupportStatus = {}));
/**
 * Whether a served PnL figure is trustworthy for the requested window.
 * 'partial' means at least one position had a synthetic-open close or a
 * missing pre-window valuation anchor — the number is incomplete and the UI
 * should flag it rather than present it as exact.
 */
export var PnlCompleteness;
(function (PnlCompleteness) {
    PnlCompleteness["Complete"] = "complete";
    PnlCompleteness["Partial"] = "partial";
})(PnlCompleteness || (PnlCompleteness = {}));
export var PositionSide;
(function (PositionSide) {
    PositionSide["Long"] = "long";
    PositionSide["Short"] = "short";
})(PositionSide || (PositionSide = {}));
/** Open vs closed filter for getPositions.input.status. */
export var PositionStatus;
(function (PositionStatus) {
    PositionStatus["Closed"] = "closed";
    PositionStatus["Open"] = "open";
})(PositionStatus || (PositionStatus = {}));
export var PreconditionStatus;
(function (PreconditionStatus) {
    PreconditionStatus["NeedsTokenApprovalTransactions"] = "needs_token_approval_transactions";
    PreconditionStatus["NeedsTokens"] = "needs_tokens";
    PreconditionStatus["NotSatisfied"] = "not_satisfied";
    PreconditionStatus["Satisfied"] = "satisfied";
})(PreconditionStatus || (PreconditionStatus = {}));
export var PredictionEventType;
(function (PredictionEventType) {
    PredictionEventType["MultiOption"] = "multi_option";
    PredictionEventType["SingleOption"] = "single_option";
    PredictionEventType["SportsMatch"] = "sports_match";
})(PredictionEventType || (PredictionEventType = {}));
export var PredictionMarketStatus;
(function (PredictionMarketStatus) {
    PredictionMarketStatus["Closed"] = "closed";
    PredictionMarketStatus["Open"] = "open";
    PredictionMarketStatus["Resolved"] = "resolved";
})(PredictionMarketStatus || (PredictionMarketStatus = {}));
export var PredictionVenue;
(function (PredictionVenue) {
    PredictionVenue["Kalshi"] = "kalshi";
    PredictionVenue["Polymarket"] = "polymarket";
})(PredictionVenue || (PredictionVenue = {}));
export var QuoteRequestType;
(function (QuoteRequestType) {
    QuoteRequestType["ExactInputQuote"] = "exact_input_quote";
    QuoteRequestType["ExactIntentQuote"] = "exact_intent_quote";
})(QuoteRequestType || (QuoteRequestType = {}));
export var QuoteType;
(function (QuoteType) {
    QuoteType["ExactInput"] = "exact_input";
    QuoteType["ExactOutput"] = "exact_output";
    QuoteType["Onramp"] = "onramp";
    QuoteType["Transfer"] = "transfer";
})(QuoteType || (QuoteType = {}));
export var RampDirection;
(function (RampDirection) {
    RampDirection["Offramp"] = "offramp";
    RampDirection["Onramp"] = "onramp";
})(RampDirection || (RampDirection = {}));
/**
 * Discriminator for unified `search`. Mirrors `InstrumentType` plus a
 * `wallet_profile` member for the wallet/profile branch — kept as its
 * own enum because wallets are not instruments and should not pollute
 * `InstrumentType`.
 */
export var SearchableEntityType;
(function (SearchableEntityType) {
    SearchableEntityType["FungibleToken"] = "fungible_token";
    SearchableEntityType["PerpetualContract"] = "perpetual_contract";
    SearchableEntityType["PredictionMarket"] = "prediction_market";
    SearchableEntityType["WalletProfile"] = "wallet_profile";
})(SearchableEntityType || (SearchableEntityType = {}));
/** Signal feed serving mode — see `ListSignalsInput.feedMode`. */
export var SignalFeedMode;
(function (SignalFeedMode) {
    SignalFeedMode["All"] = "ALL";
    SignalFeedMode["Highlights"] = "HIGHLIGHTS";
})(SignalFeedMode || (SignalFeedMode = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
export var SportDisplaySectionLayoutType;
(function (SportDisplaySectionLayoutType) {
    SportDisplaySectionLayoutType["HorizontalCarousel"] = "horizontal_carousel";
    SportDisplaySectionLayoutType["VerticalList"] = "vertical_list";
})(SportDisplaySectionLayoutType || (SportDisplaySectionLayoutType = {}));
export var Status;
(function (Status) {
    Status["InsufficientFunds"] = "insufficient_funds";
    Status["InsufficientFundsForGas"] = "insufficient_funds_for_gas";
    Status["Internal"] = "internal";
    Status["InvalidArgument"] = "invalid_argument";
    Status["NoExecutionPath"] = "no_execution_path";
    Status["Success"] = "success";
})(Status || (Status = {}));
export var TimeIntervalUnits;
(function (TimeIntervalUnits) {
    TimeIntervalUnits["Days"] = "days";
    TimeIntervalUnits["Forever"] = "forever";
    TimeIntervalUnits["Hours"] = "hours";
    TimeIntervalUnits["Minutes"] = "minutes";
    TimeIntervalUnits["Months"] = "months";
    TimeIntervalUnits["Weeks"] = "weeks";
    TimeIntervalUnits["Years"] = "years";
})(TimeIntervalUnits || (TimeIntervalUnits = {}));
export var TokenAllowlistType;
(function (TokenAllowlistType) {
    TokenAllowlistType["AllTokens"] = "all_tokens";
    TokenAllowlistType["OnlyFungibleTokens"] = "only_fungible_tokens";
    TokenAllowlistType["OnlyNonFungibleTokens"] = "only_non_fungible_tokens";
    TokenAllowlistType["OnlySemiFungibleTokens"] = "only_semi_fungible_tokens";
})(TokenAllowlistType || (TokenAllowlistType = {}));
export var TokenStandard;
(function (TokenStandard) {
    TokenStandard["Erc20"] = "erc20";
    TokenStandard["Erc721"] = "erc721";
    TokenStandard["Erc1155"] = "erc1155";
})(TokenStandard || (TokenStandard = {}));
export var TokenType;
(function (TokenType) {
    TokenType["FungibleToken"] = "fungible_token";
    TokenType["NonFungibleToken"] = "non_fungible_token";
    TokenType["SemiFungibleToken"] = "semi_fungible_token";
})(TokenType || (TokenType = {}));
export var TypeFilter;
(function (TypeFilter) {
    TypeFilter["MarketCap"] = "market_cap";
    TypeFilter["MarketCapChange"] = "market_cap_change";
    TypeFilter["Price"] = "price";
    TypeFilter["PriceChange"] = "price_change";
    TypeFilter["Rank"] = "rank";
    TypeFilter["Volume"] = "volume";
    TypeFilter["VolumeChange"] = "volume_change";
})(TypeFilter || (TypeFilter = {}));
export var VmType;
(function (VmType) {
    VmType["Evm"] = "evm";
    VmType["Svm"] = "svm";
})(VmType || (VmType = {}));
export var WaitListStatus;
(function (WaitListStatus) {
    WaitListStatus["Activated"] = "activated";
    WaitListStatus["Invited"] = "invited";
    WaitListStatus["NotJoined"] = "not_joined";
    WaitListStatus["Waiting"] = "waiting";
})(WaitListStatus || (WaitListStatus = {}));
